import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { FraccionamientoBienCulturalInterface } from '../../herramientas/models/fracciomiento.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class FracccionamientoIntegracionService {
    fraccionamientoIntegracion:BehaviorSubject<FraccionamientoBienCulturalInterface>= new BehaviorSubject<FraccionamientoBienCulturalInterface>(null)

    get fraccionamientoIntegracion$(){
        return this.fraccionamientoIntegracion.asObservable();
    }

    constructor(private apiService:ApiService) { }

    getFraccionamientoIntegraciones(bienCulturalUuid:string){
        const url= `/fraccionamiento_integracion/${bienCulturalUuid}` 
            return new Promise((resolve, reject)=>{
                this.apiService.GetMethod(url, {}, 'Error al obtener servicios.')
                    .subscribe((response:FraccionamientoBienCulturalInterface) => {
                        this.fraccionamientoIntegracion.next(response)
                        resolve(response)  
                    }, error => {
                        reject(error)
                    })
            })
    }
    
}